import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { useTable, useFilters, useSortBy, useGlobalFilter } from "react-table";
import ClipLoader from "react-spinners/ClipLoader";
import { fetchPatients, fetchDoctors } from "../Actions";
import axios from "../axios";
import SideBar from "./Sidebar";
import Adminsidebar from "./Adminsidebar";
import { addDays } from 'date-fns';
// import DoctorsList from "./Doctorslist";
 
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker, defaultStaticRanges } from 'react-date-range';
import PatientsTable from "./tables/PatientsTable";
import * as moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
 
import searchIcon from "../Assets/images/sidebar/search.svg";
import audioImg from "../Assets/images/dashboard/audio.svg";
import assessmentsImg from "../Assets/images/dashboard/doctor.svg";
import calendar from '../Assets/images/calendar.png'
import { green } from "@mui/material/colors";
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';

import Navbar from "./Navbar";
import { registerLicense } from "@syncfusion/ej2-base";
import AdminNavbar from "./Adminsidebar";
import Topbar from "./Topbar";
registerLicense("ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5RdEVjXntdcHNVQGda;MzExNjY5OUAzMjM0MmUzMDJlMzBFZmo4T0hTeUlZQjB3cjhSVFkvT0tLUDFUVEtMZU9NQXljVHk3dXloYnJ3PQ==");


const PatientsDetails = (props) => {
  let date = moment(new Date());
  const [endDate, setEndDate] = useState(new Date(date.add(1, "day").valueOf()));
  const [startDate, setStartDate] = useState(  new Date(date.subtract(1, "month").valueOf()));
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState( []);
  const [oneWeekPressed,setOneWeekPressed] = useState(false)
  const [twoWeekPressed,setTwoWeekPressed] = useState(false)
  const [oneMonthPressed,setOneMonthPressed] = useState(true)
  const [threeMonthPressed,setthreeMonthPressed] = useState(false)
  const [sixMonthPressed,setSixMonthPressed] = useState(false)
  const [searchdata,setSearchData] = useState(false);
  const [dates1, setDates1] = useState('');
  const [dates2, setDates2] = useState('');

  const [oneDay, setOneDay] = useState(false);
  const [oneWeek, setOneWeek] = useState(false);
  const [oneMonth, setOneMonth] = useState(false);
  const [oneYear, setOneYear] = useState(false);
  

  const [showCalendar, setShowCalendar] = useState(false);
  const [dateDisplay, setDateDsiplay] = useState(false);
  var _dateFns = require("date-fns");
 
  const [counttt, setCounttt] = useState();
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 30),
      key: 'selection'
    }
  ]);
  const [selectedOption, setSelectedOption] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const dateRangePickerRef = useRef(null);
  

  useEffect(() => {
    const startDate1 = moment(startDate).format("YYYY-MM-DD");
    const endDate1 = moment(endDate).format("YYYY-MM-DD");
    if (endDate !== null && startDate !== null) {
      
      
      // const startDate1 = moment(range[0].startDate).format("YYYY-MM-DD");
      // const endDate1 = moment(range[0].endDate).format("YYYY-MM-DD");

      
      setLoading(true);
      
      // getPatientsAssessments();
 
      props.fetchPatients(endDate1, startDate1).then(() =>
      setLoading(false),
      );
      setData( localStorage.getItem("user") === "admin"
      ? props.doctors.agentId
      ? filtereddata
      : rawdata
      : rawdata)
      setDates1(startDate1.toLocaleString());
      setDates2(endDate1.toLocaleString());
    } else {      
      props.fetchPatients("", "").then(() => setLoading(false));
      setDates1(startDate1.toLocaleString());
      setDates2(endDate1.toLocaleString());
    }
    // setLoading(false);
    
  }, [endDate, startDate]);
 
  useEffect(() => {
  if(!searchdata){
    setData( localStorage.getItem("user") === "admin"
    ? props.doctors.agentId
      ? filtereddata
      : rawdata
    : rawdata)
  }
 
  });

  const oneDayHandler = () => {
    setSelectedOption('1day');
    const today = moment().startOf('day').toDate();
    setStartDate(today); // Set start date to today
    setEndDate(today); // Set end date to today
  };

  const oneYearHandler = () => {
    setSelectedOption('1year');
    const startDate = moment().subtract(1, 'year').toDate();
    const endDate = moment().toDate();
    setStartDate(startDate); // Set start date 1 year ago
    setEndDate(endDate); // Set end date to end of this year
  };

  // debugger
  const handleRangeSelected = (args) => {
    const startDate1 = args.value[0];
    const endDate1 = args.value[1];
    
    setStartDate(moment(startDate1).format(("YYYY-MM-DD")));
    setEndDate(moment(endDate1).format(("YYYY-MM-DD")));
    console.log(moment(endDate1).format(("YYYY-MM-DD")));
    console.log(moment(endDate1).format(("YYYY-MM-DD")));
    setSelectedOption("")
    // setShowDatePicker(false);
    // setStartDate(start);
    // setEndDate(end);
    // Call your API with start and end dates
    // getPatients(start, end);
  };
  const handleDateRangePickerRef = (ref) => {
    if (ref && selectedOption === 'custom') {
      ref.show();
    }
  };
  
  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    // Call respective handler functions based on selected option
    if (value === '1week') {
      oneWeekHandler();
      setShowDatePicker(false);
    } else if (value === '1day') {
      oneDayHandler();
      setShowDatePicker(false);
    } else if (value === '1month') {
      oneMonthHandler();
      setShowDatePicker(false);
    } else if (value === '1year') {
      oneYearHandler();
      setShowDatePicker(false);
    } else if (value === 'custom') {
      setShowDatePicker(true);
    }
  };
 
  // console.log(props.patient.assessment_count);
 
  // console.log(props.patient.patient)
 
  const [patientId, setPatientId] = useState("");
  //For admin Id filtering(doctorlist.js)
 
  // console.log(props.doctors.doctors.userId);
  const oneWeekHandler = () => {
    setOneWeekPressed(true)
    setTwoWeekPressed(false)
    setOneMonthPressed(false)
    setthreeMonthPressed(false)
    setSixMonthPressed(false)
 
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate( new Date(newStartdate.subtract(7, "day").valueOf()))
    setEndDate( new Date(newEnddate.add(1, "day").valueOf()))
  }
  const twoWeekHandler = () => {
    setOneWeekPressed(false)
    setTwoWeekPressed(true)
    setOneMonthPressed(false)
    setthreeMonthPressed(false)
    setSixMonthPressed(false)
 
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate( new Date(newStartdate.subtract(14, "day").valueOf()))
    setEndDate( new Date(newEnddate.add(1, "day").valueOf()))
  }
  const oneMonthHandler = () => {
    setOneWeekPressed(false)
    setTwoWeekPressed(false)
    setOneMonthPressed(true)
    setthreeMonthPressed(false)
    setSixMonthPressed(false)
 
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate( new Date(newStartdate.subtract(1, "month").valueOf()))
    setEndDate( new Date(newEnddate.add(1, "day").valueOf()))
  }
  const threeMonthHandler = () => {
    setOneWeekPressed(false)
    setTwoWeekPressed(false)
    setOneMonthPressed(false)
    setthreeMonthPressed(true)
    setSixMonthPressed(false)
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate( new Date(newStartdate.subtract(2, "month").valueOf()))
    setEndDate( new Date(newEnddate.add(1, "day").valueOf()))
  }
   const sixMonthHandler = () => {
    setOneWeekPressed(false)
    setTwoWeekPressed(false)
    setOneMonthPressed(false)
    setthreeMonthPressed(false)
    setSixMonthPressed(true)
 
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate( new Date(newStartdate.subtract(6, "month").valueOf()))
    setEndDate( new Date(newEnddate.add(1, "day").valueOf()))
  }
  const filtereddata = React.useMemo(
    () =>
    {
      // console.log(props,"filtered data");
      props.patient.patient.filter(function (s) {
        // console.log(s.userId)
        // console.log(props.doctors.agentId)
        return s.userId === props.doctors.agentId;
      })
    },
    [props.patient.patient]
  );
 
  const successAssessmentsData = React.useMemo(
    () =>{
      // console.log(props, "succesass");
      props.patient.patient.filter(function (s) {
        // console.log(s.userId)
        // console.log(props.doctors.agentId)
        return s.userId === props.doctors.agentId;
      }
    
      )
    },
    [props.patient.patient]
  );
 
  // Normal Raw data
  const rawdata = React.useMemo(
    () => props.patient.patient,
    [props.patient.patient]
  );
  // console.log(props);
  
 
 
 
  const [status, setStatus] = useState("");
 
  const columns = React.useMemo(
    () =>
      localStorage.validation != "true"
        ? //admin
          localStorage.getItem("user") == "admin" ||
          localStorage.sharedPatient == "true"
          ? [
              {
                Header: "DocID/AgentID",
                accessor: "userId",
              },
 
              {
                Header: "Name",
                accessor: "firstname",
              },
              {
                Header: "Assessments",
                accessor: "records",
              },
              {
                Header: "Location",
                accessor: "location",
              },
              {
                Header: "Mobile Number",
                accessor: "mobileNumber",
              },
              {
                Header: "Gender",
                accessor: "gender",
              },
 
              {
                Header: " Enrollment Date",
                accessor: "createdOn",
              },
              {
                Header: "ID",
                accessor: "patientId",
              },
            ] //General User
          : [
              {
                Header: "DocID/AgentID",
                accessor: "userId",
              },
 
              {
                Header: "Name",
                accessor: "firstname",
              },
              {
                Header: "Assessments",
                accessor: "records",
              },
              {
                Header: "Location",
                accessor: "location",
              },
              {
                Header: "Mobile Number",
                accessor: "mobileNumber",
              },
              {
                Header: "Gender",
                accessor: "gender",
              },
 
              {
                Header: " Enrollment Date",
                accessor: "createdOn",
              },
              {
                Header: "ID",
                accessor: "patientId",
              },
            ]
        : //else condition(VALIDATION)
          [
            {
              Header: "DocID",
              accessor: "userId",
            },
            {
              Header: "Name",
              accessor: "firstname",
            },
            {
              Header: "Assessments",
              accessor: "records",
            },
            {
              Header: "Location",
              accessor: "location",
            },
            {
              Header: "Mobile Number",
              accessor: "mobileNumber",
            },
 
            {
              Header: " Enrollment Date",
              accessor: "createdOn",
            },
            {
              Header: "Status",
              accessor: "status",
            },
            {
              Header: "ID",
              accessor: "patientId",
            },
          ],
 
    []
  );
 
  const ourGlobalFilterFunctionWithPatientIdAndUserId = useCallback(
    (rows, ids, query) => {
      // console.log(rows);
      return rows.filter(
        (row) =>
          (row.values["patientId"] &&
            row.values["patientId"].toLowerCase().includes(query)) ||
          (row.values["userId"] &&
            row.values["userId"].toLowerCase().includes(query))
      );
    },
    []
  );
 
  const ourGlobalFilterFunctionWithPatientIdAndFirstName = useCallback(
    (rows, ids, query) => {
      // console.log(rows);
      return rows.filter(
        (row) =>
          (row.values["patientId"] &&
            row.values["patientId"].toLowerCase().includes(query)) ||
          (row.values["firstname"] &&
            row.values["firstname"].toLowerCase().includes(query))
      );
    },
    []
  );
 
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setFilter,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      globalFilter:
        localStorage.validation == "true" ||
        localStorage.getItem("user") == "admin"
          ? ourGlobalFilterFunctionWithPatientIdAndUserId
          : ourGlobalFilterFunctionWithPatientIdAndFirstName,
    },
    useFilters,
    useGlobalFilter,
    useSortBy
  );
  const getfetchConfigurations = async () => {
    setLoading(true)
    setSearchData(true)
    await axios
      .get(`/search_patient?userId=${localStorage.doctorId}&patientId=${patientId}`, {
      
        headers: { accessToken: localStorage.accessToken },
      })
      .then((response) => {
        if(response.status == 200){
 
      if(response.data.message){
        setData([]);
      }else{
        setData(response.data.patientData);
      }
 
 
    setLoading(false)
setSearchData(false)
        }
        else {
   setSearchData(false)
          setLoading(false)
        }
      });
  };
  const patientIdFilter = () => {
    // console.log(patientId);
    // console.log(typeof patientId);
  getfetchConfigurations();
    // console.log(filterEmailId)
    // console.log(typeof(filterEmailId))
    // setFilter('patientId', patientId === '' ? undefined : patientId);
    // setGlobalFilter(patientId.toLowerCase());
    
  };
 
  const statusFilter = () => {
    // console.log(status);
    setFilter("status", status === "" ? undefined : status);
  };
 
  var inPatient = 0;
  var outPatient = 0;
  var completedPatients = 0;
  var totalAssessments = 0;
  for (var i = 0; i < props.patient.count; i++) {
    totalAssessments += props.patient.patient[i].records.length;
    if (props.patient.patient[i].patient_type === "In Patient") {
      inPatient = inPatient + 1;
    }
    if (props.patient.patient[i].patient_type === "Out Patient") {
      outPatient = outPatient + 1;
    }
    if (props.patient.patient[i].status === "COMPLETED") {
      completedPatients = completedPatients + 1;
    }
  }
 
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 1000;
  React.useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);
 
  // const [lastKey, setLastKey] = useState("");
  // const [rowss, setRowss] = useState([]);
  // const [disable,setdisable] = useState(false);
 
 
 
  // const getPatientsAssessments = () => {
  //   axios
  //     .get(`getPatientsAssessments?page_limit=50`, {
  //       headers: { accessToken: localStorage.accessToken },
  //     })
  //     .then((response) => {
  //       console.log('getPatientsAssessments', response);
  //       // setMessage(response.data.message);
  //       setLastKey(response.data.last_e_key);
  //       setRowss(response.data.data.patients);
  //       if (response.data.last_e_key === "e30=") {
  //         setdisable(true);
  //       } else if(response.data.data.start_key === "e30="){
  //         setdisable(true);
  //       }else{
  //         setdisable(false);
  //       }
  //     })
  // }

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const customRangeHandler = () => {
    console.log('Handled');
  }

  // const handleDocumentClick = (event) => {
  //   if (dateRangePickerRef.current && !dateRangePickerRef.current.element.contains(event.target)) {
  //     setShowDatePicker(false);
  //   }
  // };
  // useEffect(() => {
  //   document.addEventListener('click', handleDocumentClick);
  //   return () => {
  //     document.removeEventListener('click', handleDocumentClick);
  //   };
  // }, []);
 
  return (
    <div>
      {props.loading ? (
        <div className="loadingdiv">
          <ClipLoader color={"#fd8c00"} loading={props.loading} size={30} />
        </div>
      ) : (
        <div>
          {/* {localStorage.user === "doctor" && <Navbar patients />}
          {localStorage.user === "admin" && <AdminNavbar patients />} */}
          <div className="dashboard">
            {/* {localStorage.user === "admin" && <Adminsidebar patients />} */}
            {/* {localStorage.user === "doctor" && <SideBar patients />} */}
      
            {/* {width < breakpoint ? (
              <div className="mobiletitle" style={{ paddingLeft: "2rem" }}>
                Swaasa
              </div>
            ) : (
              <div></div>
            )} */}
      
            <div className="dashboard__content">
              <Topbar />
              <div className="patients__filters">
                {localStorage.validation === "true" ? (
                  <div className="dashboard__patientsummary">
                    <div className="card2">
                      <div className="card2--info__content">
                        <p className="card2--info__title">Total Patients Scanned</p>
                        <img src={audioImg} alt="patients" />
                        <p className="card2--info__count">{props.patient.count}</p>
                      </div>
                      <p
                        className="card2--info__description"
                        style={{ color: "#46360999" }}
                      >
                        Total number of patients registered in the selected location
                      </p>
                    </div>
                    <div className="card2 card2--assessments">
                      <div className="card2--info__content">
                        <p className="card2--info__title">Total patients completed</p>
                        <img src={assessmentsImg} alt="assessments" />
                        <p className="card2--info__count">{completedPatients}</p>
                      </div>
                      <p
                        className="card2--info__description"
                        style={{ color: "#1ad94799" }}
                      >
                        Number of patients who have completed study
                      </p>
                    </div>
                    <div className="card2 card2--assessments">
                      <div className="card2--info__content">
                        <p className="card2--info__title">In patients/out Patient</p>
                        <img src={assessmentsImg} alt="assessments" />
                        <p className="card2--info__count">
                          {/* {(
                        props.analytics.assessmentsCount /
                        props.analytics.records.length
                      ).toFixed(1)} */}
                          {inPatient} / {outPatient}
                        </p>
                      </div>
                      <p
                        className="card2--info__description"
                        style={{ color: "#1ad94799" }}
                      >
                        Number of In patients / out patients
                      </p>
                    </div>
                    <div className="card2 card2--assessments">
                      <div className="card2--info__content">
                        <p className="card2--info__title">Total Assessments</p>
                        <img src={assessmentsImg} alt="assessments" />
                        <p className="card2--info__count">{totalAssessments}</p>
                      </div>
                      <p
                        className="card2--info__description"
                        style={{ color: "#1ad94799" }}
                      >
                        Number of Assessments
                      </p>
                    </div>
                    <div className="card2 card2--assessments">
                      <div className="card2--info__content">
                        <p className="card2--info__title">Valid Patients</p>
                        <img src={assessmentsImg} alt="assessments" />
                        <p className="card2--info__count">
                          {props.patient.valid_patients_count}
                        </p>
                      </div>
                      <p
                        className="card2--info__description"
                        style={{ color: "#1ad94799" }}
                      >
                        Number of valid Patients
                      </p>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
      
              {/* {localStorage.search == "true" && ( <div className="patients__name-filter">
                  <input
                    type="text"
                    value={patientId}
                    onChange={(e) => setPatientId(e.target.value)}
                    placeholder="Search By Patient ID"
                  />
                  <button onClick={() => patientIdFilter()}>
                    <img src={searchIcon} alt="search" />
                  </button>
                </div>)} */}
              </div>
              <>
              {/* <div className="calendarView">
                <button className="calendarButton" onClick={toggleCalendar}> &nbsp; <img className="calendarImg" src={calendar} alt="" /> { startDate.toLocaleDateString()} &nbsp; To &nbsp; {endDate.toLocaleDateString()} </button>
              </div> */}
              {/* {showCalendar && (
                <div className="patients__value-filter" style={{alignSelf: "center"}}>
                  <div className="patients__value-filter__item">
                    <div className="dateText">
                      <p>Custom Date Range</p>
                      <p>From Date:</p>
                      <p>To Date:</p>
                    </div>
                    <p>Custom Date Range &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; From Date: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;      To Date:</p>
                    <DateRangePicker
                      onChange={item => setRange([item.selection])}
                      showSelectionPreview={true}
                      moveRangeOnFirstSelection={false}
                      // months={2}
                      ranges={range}
                      direction="horizontal"
                      showCalendar={false}
                      // showDateDisplay={false}
                      showMonthAndYearPickers={false}
                      staticRanges={staticRanges}
                    />
                  </div>
                </div>
              )} */}
              <div className="dateSelection">
                <select className="selectDate" id="duration" value={selectedOption} onChange={handleChange}>
                  <option value="1month">Date Range</option>
                  <option value="1month">1 Month</option>
                  <option value="1week">1 Week</option>
                  <option value="1year">1 Year</option>
                  <option value="1day">1 Day</option>
                  <option value="custom" key="">Custom</option>
                </select>
                {/* <DateRangePickerComponent id="daterangepicker" /> */}
                {showDatePicker && (
                  <div className="dateRangePicker">
                    <DateRangePickerComponent
                      id="daterangepicker"
                      placeholder="Select a range"
                      startDate={startDate}
                      endDate={endDate}
                      showClearButton={false}
                      onChange={handleRangeSelected}
                      ref={(ref) => handleDateRangePickerRef(ref)}
                    />
                  </div>
                )}
                <div className="dates-container">
                  <p className="dates">{dates1} </p>
                  <p className="dates">to</p>
                  <p className="dates">{dates2} </p>
                </div>
              </div>
                {/* {localStorage.filters == "true" ? (<div className="filters">
                <div onClick={oneWeekHandler}  class={oneWeekPressed ? "SelectboxBG" : "NotSelectboxBG"}>
                <span class={ oneWeekPressed ? "w" : "Nw"}>1w</span>
                </div>
                <div onClick={twoWeekHandler} class={twoWeekPressed ? "SelectboxBG" : "NotSelectboxBG"}>
                <span class={ twoWeekPressed ? "w" : "Nw"}>2w</span>
                </div>
                <div onClick={oneMonthHandler}  class={oneMonthPressed ? "SelectboxBG" : "NotSelectboxBG"}>
                <span class={ oneMonthPressed ? "w" : "Nw"}>1m</span>
                </div>
                <div onClick={threeMonthHandler}  class={threeMonthPressed ? "SelectboxBG" : "NotSelectboxBG"}>
                <span class={ threeMonthPressed ? "w" : "Nw"}>3m</span>
                </div>
                <div onClick={sixMonthHandler}  class={sixMonthPressed ? "SelectboxBG" : "NotSelectboxBG"}>
                <span class={ sixMonthPressed ? "w" : "Nw"}>6m</span>
                </div>
                </div>) : <></>} */}
                
      
                {/* {localStorage.validation != "true" ? (
                  ""
                ) : (
                  <div className="patients__value-filter">
                    <div className="patients__value-filter__item">
                      <p>Status</p>
                      <select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value="">All</option>
                        <option value="NEW">NEW</option>
                        <option value="COMPLETED">COMPLETED</option>
                      </select>
                      <button
                        onClick={() => statusFilter()}
                        className="patients__value-filter__btn1"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                )} */}
              </>
      
              {!loading ? (
                <PatientsTable
                  // getTableProps={getTableProps}
                  // getTableBodyProps={getTableBodyProps}
                  // headerGroups={headerGroups}
                  // prepareRow={prepareRow}
                  // loading={loading}
                  // lastKey={lastKey}
                  // rowsss={rowss}
                  // counttt={counttt}
                  // rows={rows}
                  // disable={disable}
                  // message={message}
                  searchData={data}
                  startDate={startDate}
                  endDate={endDate}
                  propData={data}
                />
              ) : (
                <div className="loadingdiv">
                  {/* <ClipLoader color={"#fd8c00"} size={30} /> */}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
 
const mapStateToProps = (state) => ({
  patient: state.patient,
  doctors: state.doctors,
});
 
export default connect(mapStateToProps, { fetchPatients, fetchDoctors })(
  PatientsDetails
);